var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('v-img',{staticClass:"mx-5 justify-center aling-center",attrs:{"aspect-ratio":16/9,"src":!_vm.white ? '/images/empty.png' : '/images/emptystate.jpg',"max-height":"500px","alt":"emptystate","contain":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }